import { type ReactNode, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import { LocaleSwitch } from "../auth/index.js";

/**
 * Язык публичной страницы: выбор посетителя (переключатель, хранится на устройстве), иначе язык салона.
 * Язык салона не записываем на устройство: это не выбор посетителя.
 */
export function usePublicLocale(salonLocale: string | undefined): void {
  const { i18n } = useTranslation();
  useEffect(() => {
    if (!salonLocale) return;
    let stored: string | null = null;
    try {
      stored = localStorage.getItem("locale");
    } catch {
      stored = null;
    }
    if (stored) return;
    const ui = salonLocale.startsWith("sr") ? "sr-Latn" : salonLocale === "ru" || salonLocale === "en" ? salonLocale : "sr-Latn";
    if (i18n.language !== ui) void i18n.changeLanguage(ui);
  }, [salonLocale, i18n]);
}

/** Оболочка публичных страниц салона (запись, «моя запись», уведомление о данных): под телефон, без входа. */
export function PublicShell({ salonName, slug, children }: { salonName?: string; slug?: string; children: ReactNode }) {
  const { t } = useTranslation();
  return (
    <div className="mx-auto flex min-h-dvh w-full max-w-md flex-col px-4 py-4">
      <header className="mb-4 flex items-center justify-between gap-2">
        <div className="truncate font-semibold">{salonName ?? ""}</div>
        <LocaleSwitch />
      </header>
      <main className="flex-1">{children}</main>
      <footer className="mt-10 space-y-1 border-t border-slate-200 pt-4 text-xs text-slate-500">
        {slug && (
          <Link to={`/data-notice/${slug}`} className="underline">
            {t("book.dataNotice")}
          </Link>
        )}
        <p>{t("book.poweredBy")}</p>
      </footer>
    </div>
  );
}
